import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '@mantine/core';
import useIconStyle from './Icon.style.js';
import { isString, GUI_GLOBAL_CLASS, GUI_COMP_CSS_VARIABLE_CLASS } from '../../utils/index.js';

var _excluded = ["size", "icon", "classNames", "className", "color", "styles", "unstyled", "applyColorVariable"];
var Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 16 : _props$size,
    icon = props.icon,
    classNames = props.classNames,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    color = props.color,
    styles = props.styles,
    unstyled = props.unstyled,
    _props$applyColorVari = props.applyColorVariable,
    applyColorVariable = _props$applyColorVari === void 0 ? false : _props$applyColorVari,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useIconStyle = useIconStyle({
      size: size,
      color: color
    }, {
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      name: 'Icon'
    }),
    classes = _useIconStyle.classes,
    cx = _useIconStyle.cx;
  var combinedClassName = isString(icon) ? "".concat(icon, " ").concat(className, " iconfont") : className;
  restProps.children = restProps.children || !isString(icon) && icon;
  return /*#__PURE__*/React__default.createElement(Box, _objectSpread2(_objectSpread2({}, restProps), {}, {
    component: restProps.component || 'i',
    className: cx(classes.root, combinedClassName, GUI_GLOBAL_CLASS, applyColorVariable ? GUI_COMP_CSS_VARIABLE_CLASS : undefined),
    ref: ref
  }));
});

export { Icon };
//# sourceMappingURL=Icon.js.map
